import { AppContext } from 'components/common';

import type React from 'react';

import type { JSX } from 'react';

export function withAppContext<T>(Component: ((props: T) => JSX.Element) | React.FC<T>) {
  return function WrapperComponent(props: T) {
    return <AppContext.Consumer>{(state: any) => <Component {...props} context={state} />}</AppContext.Consumer>;
  };
}
